import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './ProjectProposalForm.css';
import './ProjectProposalAddlSubItem.css';
import { getCurrentProject } from 'components/admin/projects/details/store/selectors';
import { updateProjectProposalAddlItemValue } from 'components/admin/projects/details/project-proposal/store/actions';
import TextareaAutosize from 'react-autosize-textarea';
import Input from 'components/shared/input/Input';
import numeral from 'numeral';
import Number from 'components/shared/text/Number';
import settingsPng from 'images/settings.png';
import OutsideAlerter from 'components/shared/OutsideAlerter';

class ProjectProposalAddlSubItem extends Component {
  static propTypes = {
    itemKey: PropTypes.string.isRequired,
    subItemKey: PropTypes.string.isRequired,
    subItem: PropTypes.shape({}).isRequired,
    isLastSubItem: PropTypes.bool,
    readOnly: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    isLastSubItem: false,
  };

  constructor(props) {
    super(props);

    this.state = { addlItemMenu: false };
  }

  handleChange = (attribute, value) => {
    const { itemKey, subItemKey, dispatch } = this.props;
    dispatch(
      updateProjectProposalAddlItemValue(itemKey, subItemKey, attribute, value)
    );
  };

  handleDelete = () => {
    const confirmed = window.confirm('Are you sure?');
    confirmed && this.handleChange('delete', true);
  };

  handleMenuToggle = () => {
    const { addlItemMenu } = this.state;
    this.setState({ addlItemMenu: !addlItemMenu });
  };

  renderSettings = () => {
    const { addlItemMenu } = this.state;
    return (
      <div className="proposal-item-settings">
        <div className="settings-icon" onClick={this.handleMenuToggle}>
          <img src={settingsPng} alt="settings" />
        </div>
        {addlItemMenu && (
          <OutsideAlerter onClickOutside={this.handleMenuToggle}>
            <div className="settings-menu">
              <div className="settings-menu-item" onClick={this.handleDelete}>
                Delete
              </div>
            </div>
          </OutsideAlerter>
        )}
      </div>
    );
  };

  render() {
    const { subItem, isLastSubItem, currentProject, readOnly } = this.props;
    return (
      <tr className="project-proposal-addl-sub-item">
        <td>{!readOnly && isLastSubItem && this.renderSettings()}</td>
        <td />
        <td>
          {readOnly ? (
            subItem.summary
          ) : (
            <TextareaAutosize
              rows={1}
              placeholder="Add Summary"
              defaultValue={subItem.summary || ''}
              onBlur={(e) => this.handleChange('summary', e.target.value)}
            />
          )}
        </td>
        <td>
          {readOnly ? (
            <Number value={subItem.cost || ''} format="$ 0,0" />
          ) : (
            <Input
              placeholder="$0"
              value={subItem.cost ? numeral(subItem.cost).format('$ 0,0') : ''}
              onChange={(value) =>
                this.handleChange('cost', numeral(value).value())
              }
            />
          )}
        </td>
        <td>
          <Number
            value={subItem.cost ? subItem.cost / currentProject.sq_footage : ''}
            format="$ 0,0.[00]"
          />
        </td>
        <td />
      </tr>
    );
  }
}

export default connect((state) => {
  return {
    currentProject: getCurrentProject(state),
  };
})(ProjectProposalAddlSubItem);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-proposal/ProjectProposalAddlSubItem.js